import { Indicator, Root as ProgressRoot } from "@radix-ui/react-progress";
import React from "react";
import { cn } from "@/lib/utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressRoot>,
  React.ComponentPropsWithoutRef<typeof ProgressRoot>
>(({ className, value, ...props }, ref) => {
  const percent = value ?? 0;

  return (
    <ProgressRoot
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full",
        className,
      )}
      {...props}
    >
      <Indicator
        className={`h-full w-full flex-1 bg-primary transition-all rounded-[10px] [background:linear-gradient(90deg,rgb(84.71,155.67,255)_0%,rgb(255,167.03,167.03)_100%)]`}
        style={{ width: `${percent}%` }}
      />
    </ProgressRoot>
  );
});
Progress.displayName = ProgressRoot.displayName;

export default Progress;
